import React, { useState, useEffect, useCallback } from 'react';
import { defaultAttributionWindow } from '../../../../utils/constants/constants';

const BasketItemsController = ({
  children,
  url,
  expiresAt,
  refetch,
  chartData,
  setChartData,
  reportName,
  campaignOrder,
  currentUser,
  location,
  ...props
}) => {
  const [rawData, setRawData] = useState(null);
  const [loadingRawData, setLoadingRawData] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [attributionWindow, setAttributionWindow] = useState(365);

  const dataConfig =
    currentUser && currentUser.role && currentUser.role.org && currentUser.role.org.dataConfig;
  const defaultDisplayAttributionWindow =
    (dataConfig && dataConfig.defaultDisplayAttributionWindow) || defaultAttributionWindow.key;

  const fetchData = useCallback(async () => {
    if (!url) return;

    setLoadingRawData(true);
    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

      const json = await response.json();
      if (
        defaultDisplayAttributionWindow !== 30 &&
        json.attributionWindowReports &&
        json.attributionWindowReports.length > 0
      ) {
        const report = json.attributionWindowReports.find(
          (report) => report.attributionWindow === defaultDisplayAttributionWindow
        );
        if (report) {
          json.data = report.data;
          json.count = report.count;
        }
      }
      setRawData(json);
    } catch (err) {
      console.error(err);
    } finally {
      setLoadingRawData(false);
    }
  }, [url, defaultDisplayAttributionWindow]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  useEffect(() => {
    if (rawData && rawData.data && !chartData.basketItems) {
      setChartData({
        ...chartData,
        basketItems: rawData.data,
      });
    }
  }, [rawData, chartData, setChartData]);

  return React.cloneElement(children, {
    ...props,
    chartData: rawData,
    chartsLoading: loadingRawData,
    reportName,
    searchTerm,
    setSearchTerm,
    attributionWindow,
    setAttributionWindow,
    campaignOrderId: campaignOrder && campaignOrder.id,
    currentUser,
  });
};

export default BasketItemsController;
